import { connectedAccountsListRequested } from '../actions';
import { mutator } from 'satcheljs';
import getStore from '../store/store';
import { AccountsStoreState } from '../store/schema/AccountsStoreState';

/**
 * This mutator is triggered from owa-account-store-init
 */
/* eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!
 *	> Please use a mutatorAction if action is defined in the same package */
mutator(connectedAccountsListRequested, actionMessage => {
    const newLoadState = actionMessage.isSuccess
        ? AccountsStoreState.AccountsLoadSuccessful
        : AccountsStoreState.AccountsLoadError;
    getStore().accountsLoadedState = newLoadState;
});
